import { PostalCode } from './../model/postal-code.model';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Observable, Subject, fromEvent, map, filter, debounceTime, distinctUntilChanged } from 'rxjs';
import { MsgModel } from '../../msg/model/msg.model';
import { Country } from '../model/country.model';
import { PostalAddressService } from '../service/postal-address.service';

@Component({
  selector: 'input-zipcode',
  templateUrl: './input-zipcode.component.html',
  styleUrl: './input-zipcode.component.scss'
})
export class InputZipcodeComponent{
  @Input() id: string = 'Zipcode';
    @Input() name: string = 'Zipcode';
    @Input() label: string = 'Zipcode';
    @Input() placeholder: string = 'Zipcode';
    @Input() required: boolean = false;
    @Input() selectedZipcode: PostalCode = { POSTAL_CODE: '' };
    @Output() selectedZipcodeChange: EventEmitter<PostalCode> = new EventEmitter<PostalCode>();

    @Input() country: Country | undefined;
    @Output() countryChange: EventEmitter<Country> = new EventEmitter<Country>();

    @Input() stateId!: number;
    @Input() countryId!: number;
    @Input() disabled: boolean;

    isLoading: boolean = false;
    msg: MsgModel = new MsgModel();

    minCharacters = 3;

    zipcodes!: PostalCode[];

    constructor(private postalAddressService: PostalAddressService) {}

    onZipcodeInput(event: Event): void {
      const input = (event.target as HTMLInputElement);

      input.value = input.value.replace(/\D/g, '').slice(0, 5);
      this.selectedZipcode.POSTAL_CODE = input.value;
    }
}
